import { __assign } from "tslib";
import React from 'react';
import Button from './Button';
export default function SaveButton(props) {
    return (React.createElement(Button, __assign({ hoverColor: "green", px: 12 }, props), "Save"));
}
